import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Problem from './components/Problem';
import Features from './components/Features';
import Stats from './components/Stats';
import HowItWorks from './components/HowItWorks';

import FAQ from './components/FAQ';
import LeadCapture from './components/LeadCapture';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function App() {
  return (
    <div data-testid="app-root" className="app-shell">
      <Navbar />
      <Hero />
      <Marquee />
      <Problem />
      <Features />
      <Stats />
      <HowItWorks />

      <FAQ />
      <LeadCapture />
      <CTA />
      <Footer />
    </div>
  );
}
